// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';

class VenueInfo extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue : this.props.venue,
      data:[],
      loading: true
    };
    this.handleBuddyClick = this.handleBuddyClick.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getVenueDetails();
    this.getVenueImages();
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueDetails(){
    console.log('getVenueDetails')
    console.log('venue_id',this.state.venue)
    const url = `${getLocationOrigin()}/get_venue_list/get_venue_buddies/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
       if(data.success){
         this.setState({data:data.result,loading:false});
       }
       else{
        this.setState({loading:false})
        alert(data.message)
       }
     }).catch(error => error);
    }

  // Every venue image (not just the four legacy slots in get_venue_buddies).
  getVenueImages(){
    const url = `${getLocationOrigin()}/get_venue_list/get_venue_images/?venue_id=${this.state.venue}`;
    const options = {...defaultOptions};
    return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
       if(data.success){
         this.setState({venue_images:data.images});
       }
     }).catch(error => console.log(error));
  }

  handleBuddyClick(event){
    const id = event.target.value
    window.location.href = `./#/crud/updateBuddy/${id}`
  }

  render() {
    console.log('venue',this.props)
    return(
      <div style={styles.container}>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div style={styles.page}>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Buddies</h3>
              {['Center Manager', 'Desk Associate', 'Lead Buddy', 'Area Manager', 'Trainer'].map(role => {
                const buddies = this.state.data[role];
                return (
                  buddies && buddies.length > 0 && (
                    <div key={role} style={styles.roleGroup}>
                      <span style={styles.roleTitle}>{role}</span>
                      <span style={styles.namesList}>
                        {buddies.map(b => b.name).join(', ')}
                      </span>
                    </div>
                  )
                );
              })}
            </div>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Amenities</h3>
              {this.state.data.amenities && this.state.data.amenities.length > 0 ? (
                <div style={styles.amenitiesList}>
                  {this.state.data.amenities.map((amenity, index) => (
                    <span key={index} style={styles.amenityItem}>
                      {amenity.value}
                    </span>
                  ))}
                </div>
              ) : (
                <div style={styles.noAmenities}>No Amenities</div>
              )}
            </div>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Venue Images</h3>
              { (this.state.venue_images || []).length > 0 ?
                <div style={styles.imageGrid}>
                  { this.state.venue_images.map((image, index) => (
                    <a key={image.id} href={image.url} target="_blank" rel="noopener noreferrer" title="Open full image">
                      <img src={image.url} alt={'Image ' + (index + 1)} style={styles.imageThumb} />
                    </a>
                  ))}
                </div>
                :
                <div style={styles.noAmenities}>No Images Available</div>
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

export default VenueInfo;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueInfo/VenueInfo.js